module.exports = __webpack_public_path__ + "static/4-b63d16500558ead634735f27097781bf.png";